// extracted by mini-css-extract-plugin
export default {"container":"ScenarioCarousels_container__Bqa5o","tabsWrapper":"ScenarioCarousels_tabsWrapper__RTDX5","recommendedTags":"ScenarioCarousels_recommendedTags__zQscx"};